import React from 'react';
import styled from 'styled-components';

import { useOptionContext } from './option-context';

/** Strikethrough original price for an option tile. Renders nothing when no original price or discount applies. */
export function TileOriginalPrice(): JSX.Element | null {
  const { originalPrice, discountLabel, listPriceEnabled, hideStrikethrough, formatStandardPrice } = useOptionContext();

  if (!discountLabel || !originalPrice) {
    return null;
  }

  return (
    <OriginalPrice $listPriceEnabled={listPriceEnabled} $hideStrikethrough={hideStrikethrough}>
      {formatStandardPrice(originalPrice)}
    </OriginalPrice>
  );
}

const OriginalPrice = styled.span<{ $listPriceEnabled?: boolean; $hideStrikethrough?: boolean }>`
  color: ${({ $listPriceEnabled }) =>
    $listPriceEnabled
      ? 'var(--dcm-product-detail-muted-color)'
      : 'var(--dcm-product-price-strikethrough-color, #485055)'};
  display: block;
  text-decoration: ${({ $hideStrikethrough }) => ($hideStrikethrough ? 'none' : 'line-through')};
`;
